var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2636 1.78927C10.0965 1.71154 9.90354 1.71154 9.73642 1.78927L2.86142 4.98695C2.64098 5.08948 2.5 5.31053 2.5 5.55365V14.4464C2.5 14.6895 2.64098 14.9105 2.86142 15.0131L9.73642 18.2107C9.90354 18.2885 10.0965 18.2885 10.2636 18.2107L17.1386 15.0131C17.359 14.9105 17.5 14.6895 17.5 14.4464V5.55365C17.5 5.31053 17.359 5.08948 17.1386 4.98695L10.2636 1.78927ZM4.0119 5.71555L10 2.93039L15.9881 5.71555L10 8.53348L4.0119 5.71555ZM16.3542 6.80965V14.1142L10.5729 16.8032V9.53024L16.3542 6.80965ZM9.42708 9.53024V16.8032L3.64583 14.1142V6.80965L9.42708 9.53024Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/sample.613215ae79e167d0a871904e4e2838af.svg";
export { ForwardRef as ReactComponent };